<template>
  <div class="album-page-container">
    <header class="album-header-card">
      <div v-if="albumInfo" class="album-info-wrapper">
        <div class="album-cover-box">
          <el-image lazy fit="cover" class="header-cover-img" :src="albumInfo.coverUrl" />
          <div class="cover-glass-overlay" />
        </div>

        <div class="album-detail-content">
          <div class="top-row">
            <h2 class="album-title">{{ albumInfo.albumName || '播放列表' }}</h2>
            <el-button type="primary" size="medium" icon="el-icon-video-play" class="play-all-btn" @click="onPlayAlbum">播放全部</el-button>
          </div>

          <div class="filter-row">
            <div class="select-group">
              <span class="label hidden-xs-only">切换列表：</span>
              <el-select
                v-model="queryInfo.albumId"
                size="small"
                class="album-select-custom"
                @change="onSelectChange"
              >
                <el-option
                  v-for="item in allAlbums"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div class="stats-tags">
              <el-tag size="small" effect="plain" class="custom-tag-grey">{{ albumInfo.total }} 个稿件</el-tag>
              <el-tag size="small" effect="dark" class="custom-tag-success mgl-8">{{ albumInfo.scopeStr }}</el-tag>
            </div>
          </div>
        </div>
      </div>
    </header>

    <main class="album-main-content">
      <div v-if="dataList.length === 0" class="empty-status">
        <el-empty description="暂无收藏内容" :image-size="150" />
      </div>

      <el-row :gutter="20" class="video-grid">
        <el-col
          v-for="(item, index) in dataList"
          :key="index"
          :xs="12"
          :sm="8"
          :md="6"
          :lg="4"
          :xl="4"
          class="video-col"
        >
          <el-card :body-style="{ padding: '0px' }" class="video-card-modern" shadow="never">
            <div class="card-image-box">
              <router-link :to="`/video/${item.videoId}`" target="_blank">
                <el-image lazy fit="cover" class="card-cover" :src="item.coverUrl" />
                <div class="card-badges">
                  <span class="duration-badge"><i class="el-icon-time" /> {{ item.duration }}</span>
                  <span class="device-icon-badge">
                    <i :class="item.horizontal ? 'el-icon-monitor' : 'el-icon-mobile-phone'" />
                  </span>
                </div>
                <div class="play-hover-mask">
                  <i class="el-icon-video-play play-center-icon" />
                </div>
              </router-link>
            </div>

            <div class="card-info">
              <router-link :to="`/video/${item.videoId}`" target="_blank" class="video-title-link">
                <h4 class="video-title">{{ item.title }}</h4>
              </router-link>

              <div class="video-meta">
                <router-link :to="`/user/${item.user.userId}`" target="_blank" class="user-link">
                  <i class="el-icon-user" /> {{ item.user.screenName }}
                </router-link>
                <span class="pub-date">{{ item.pubDateStr }}</span>
              </div>

              <div class="card-btns">
                <el-button-group class="full-width-btns">
                  <el-tooltip content="设为封面" placement="top" :disabled="screenWidth < 768">
                    <el-button size="mini" class="btn-action-grey" icon="el-icon-picture-outline" @click="onSetCover(item)" />
                  </el-tooltip>
                  <el-tooltip content="删除收藏" placement="top" :disabled="screenWidth < 768">
                    <el-button size="mini" class="btn-action-danger" icon="el-icon-delete" @click="onDeleteItem(item)" />
                  </el-tooltip>
                </el-button-group>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>

      <div class="pagination-wrapper">
        <el-pagination
          background
          :small="screenWidth < 768"
          layout="total, prev, pager, next"
          :page-size="pageSize"
          :current-page="currentPage"
          :total="totalSize"
          @current-change="handleCurrentChange"
        />
      </div>
    </main>

    <el-backtop target=".admin-main" />
  </div>
</template>

<script>
import { doAlbumAction, getAlbumItems, getUserAlbumSelectList, setAlbumCover } from '@/api/vod'

export default {
  name: 'MyFav',
  data() {
    return {
      allAlbums: [],
      queryInfo: {
        postType: 2,
        albumId: '0',
        pn: 1
      },
      screenWidth: document.body.clientWidth,
      currentPage: 1,
      pageSize: 12,
      totalSize: 0,
      dataList: [],
      albumInfo: null
    }
  },
  created() {
    const { albumId, pn } = this.$route.query
    this.queryInfo.albumId = albumId ? String(albumId) : '0'
    if (pn) {
      this.queryInfo.pn = parseInt(pn)
      this.currentPage = parseInt(pn)
    }
    this.getSelectList()
    this.getData()
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      this.screenWidth = document.body.clientWidth
    },
    onSelectChange() {
      this.queryInfo.pn = 1
      this.currentPage = 1
      this.updateRouteAndData()
    },
    handleCurrentChange(page) {
      this.currentPage = page
      this.queryInfo.pn = page
      this.updateRouteAndData()
      const container = document.querySelector('.admin-main')
      if (container) container.scrollTo({ top: 0, behavior: 'smooth' })
    },
    updateRouteAndData() {
      this.$router.push({ path: '/bg/my/album', query: this.queryInfo })
      this.getData()
    },
    getSelectList() {
      const queryInfo = {
        postType: 2
      }
      getUserAlbumSelectList(queryInfo).then(resp => {
        if (resp.code === 0) {
          this.allAlbums = resp.data
          if (this.queryInfo.albumId === '0') {
            this.queryInfo.albumId = this.allAlbums[0].value
            this.$router.push({
              path: '/bg/my/album',
              query: this.queryInfo
            })
          }
        }
      })
    },
    getData() {
      getAlbumItems(this.queryInfo).then(resp => {
        if (resp.code === 0) {
          this.albumInfo = resp.data.albumInfo
          if (resp.data.videoList !== undefined && resp.data.videoList != null) {
            this.dataList = resp.data.videoList.list
            this.totalSize = resp.data.videoList.totalSize
          } else {
            this.dataList = []
            this.totalSize = 0
          }
        }
      })
    },
    onSetCover(item) {
      const jsonData = {
        albumId: this.albumInfo.albumId,
        postId: item.videoId,
        action: 3
      }
      setAlbumCover(jsonData).then(res => {
        if (res.code === 0) {
          this.$message.success('已更新封面')
          this.getData()
        }
      })
    },
    onDeleteItem(item) {
      this.$confirm('确定移除该收藏吗？', '提示', { type: 'warning' }).then(() => {
        doAlbumAction({ albumId: this.albumInfo.albumId, postId: item.videoId, action: 2 }).then(res => {
          if (res.code === 0) {
            this.$message.success('已移除')
            this.getData()
          }
        })
      }).catch(() => {})
    },
    onPlayAlbum() { this.$message.info('播放列表功能建设中') }
  }
}
</script>

<style scoped>
/* ==================== 1. 全局容器与精细化头部 ==================== */
.album-page-container {
  padding: 16px;
  max-width: 1440px;
  margin: 0 auto;
}

.album-header-card {
  background: #ffffff;
  border-radius: 12px;
  padding: 28px;
  margin-bottom: 24px;
  border: 1px solid #f0f2f5;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
}

.album-info-wrapper {
  display: flex;
  gap: 28px;
  align-items: center;
}

.album-cover-box {
  position: relative;
  width: 192px;
  height: 120px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
}

.header-cover-img {
  width: 100%;
  height: 100%;
  transition: transform 0.6s ease;
}

.album-cover-box:hover .header-cover-img {
  transform: scale(1.05);
}

.album-detail-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.album-title {
  margin: 0;
  font-size: 22px;
  color: #1d2129;
  font-weight: 600;
  letter-spacing: -0.2px;
}

.play-all-btn {
  background: #409EFF;
  border: none;
  padding: 10px 20px;
  font-weight: 500;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  transition: all 0.25s ease;
}

.play-all-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(64, 158, 255, 0.45);
}

.filter-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: 1px dashed #f2f3f5;
  padding-top: 16px;
}

.select-group {
  display: flex;
  align-items: center;
}

.select-group .label {
  font-size: 13px;
  color: #86909c;
}

/* 隐藏 Element 默认边框线，改为平滑现代化设计 */
::v-deep .album-select-custom .el-input__inner {
  border-radius: 6px;
  background-color: #f2f3f5;
  border: 1px solid transparent;
  color: #4e5969;
  font-weight: 500;
  transition: all 0.2s;
}

::v-deep .album-select-custom .el-input__inner:focus {
  background-color: #ffffff;
  border-color: #409EFF;
}

/* 细化标签层级 */
.custom-tag-grey {
  background-color: #f2f3f5 !important;
  color: #4e5969 !important;
  border: none !important;
  border-radius: 4px;
}

.custom-tag-success {
  background-color: #e8ffea !important;
  color: #00b42a !important;
  border: none !important;
  border-radius: 4px;
  font-weight: 500;
}

.mgl-8 { margin-left: 8px; }

/* ==================== 2. 视频网格与现代卡片 ==================== */
.video-grid { margin: 0 -10px; }

.video-card-modern {
  border-radius: 10px;
  border: 1px solid #f2f3f5;
  background: #ffffff;
  margin-bottom: 24px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
}

/* 鼠标悬浮整体上浮、带柔和拟物阴影 */
.video-card-modern:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(29, 33, 41, 0.08);
  border-color: #e5e6eb;
}

.card-image-box {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  background-color: #f7f8fa;
  overflow: hidden;
}

.card-cover {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  transition: transform 0.4s ease;
}

.video-card-modern:hover .card-cover {
  transform: scale(1.04);
}

/* 悬浮遮罩及中心播放小图标 */
.play-hover-mask {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.video-card-modern:hover .play-hover-mask {
  opacity: 1;
}

.play-center-icon {
  font-size: 36px;
  color: rgba(255, 255, 255, 0.9);
  text-shadow: 0 2px 8px rgba(0,0,0,0.3);
}

/* 精致的小微章 */
.card-badges {
  position: absolute;
  bottom: 0; left: 0; right: 0;
  padding: 20px 8px 6px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.55) 0%, rgba(0, 0, 0, 0) 100%);
  color: #fff;
  font-size: 11px;
  z-index: 2;
}

.duration-badge {
  background: rgba(0, 0, 0, 0.6);
  padding: 2px 6px;
  border-radius: 4px;
  letter-spacing: 0.2px;
  display: flex;
  align-items: center;
  gap: 3px;
}

.device-icon-badge {
  background: rgba(0, 0, 0, 0.6);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-info { padding: 12px; }

.video-title-link { text-decoration: none; }

.video-title {
  margin: 0 0 8px 0;
  font-size: 14px;
  font-weight: 500;
  height: 40px;
  line-height: 20px;
  color: #1d2129;
  transition: color 0.2s;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.video-card-modern:hover .video-title {
  color: #409EFF;
}

.video-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  color: #86909c;
  margin-bottom: 12px;
}

.user-link {
  color: #4e5969;
  text-decoration: none;
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 3px;
}
.user-link:hover { color: #409EFF; }

/* ==================== 3. 功能按钮卡片优化 ==================== */
.card-btns {
  border-top: 1px dashed #f2f3f5;
  padding-top: 10px;
  margin-top: 4px;
}

.full-width-btns { display: flex; width: 100%; gap: 8px; }
.full-width-btns .el-button {
  flex: 1;
  border-radius: 4px !important;
  border: 1px solid #f2f3f5;
}

.btn-action-grey {
  background: #f7f8fa;
  color: #4e5969;
}
.btn-action-grey:hover {
  background: #e8f4ff !important;
  color: #409EFF !important;
  border-color: #c6e2ff !important;
}

.btn-action-danger {
  background: #fffdfd;
  color: #f56c6c;
}
.btn-action-danger:hover {
  background: #fef0f0 !important;
  color: #f56c6c !important;
  border-color: #fde2e2 !important;
}

.pagination-wrapper { padding: 32px 0 16px 0; display: flex; justify-content: center; }

/* ==================== 4. 完美移动端响应式适配 ==================== */
@media screen and (max-width: 768px) {
  .album-page-container { padding: 10px; }

  .album-header-card { padding: 16px; margin-bottom: 16px; border-radius: 8px; }

  .album-info-wrapper { flex-direction: column; gap: 14px; align-items: stretch; text-align: left; }

  .album-cover-box { width: 100%; height: auto; padding-top: 45%; /* 移动端调整大拉伸或者横幅 */ }
  .album-cover-box .header-cover-img { position: absolute; top:0; left:0; }

  .top-row { flex-direction: row; align-items: center; gap: 12px; }

  .album-title { font-size: 18px; flex: 1; }

  .play-all-btn { padding: 8px 14px; font-size: 12px; }

  .filter-row { flex-direction: column; gap: 12px; align-items: stretch; border-top: 1px solid #f2f3f5; }

  .album-select-custom { width: 100%; }

  .stats-tags { display: flex; justify-content: flex-start; }

  .video-grid { margin: 0 -4px; }

  .video-col { padding: 0 4px !important; }

  .video-card-modern { border-radius: 6px; margin-bottom: 8px; }

  .card-info { padding: 8px; }

  .video-title { font-size: 13px; height: 36px; line-height: 18px; margin-bottom: 4px; }

  .video-meta { flex-direction: column; align-items: flex-start; gap: 2px; margin-bottom: 8px; font-size: 11px; }

  .user-link { max-width: 100%; }

  .card-btns { padding-top: 8px; }
  .full-width-btns { gap: 4px; }
  .full-width-btns .el-button { padding: 6px 0; }
}

@media screen and (max-width: 767px) {
  .hidden-xs-only { display: none !important; }
}
</style>
